import { Component } from '@angular/core';

import { PageNotFoundComponent } from '@ciphr/shared/page-not-found';

@Component({
  standalone: true,
  imports: [PageNotFoundComponent],
  template: ` <ciphr-page-not-found [header]="true" /> `,
  styles: [':host { height: 100vh; }'],
})
export default class AppPageNotFoundComponent {}
